import constants from './BaseConstants';
export default {
  CUSTOMER_URL: constants.BASE_URL + 'admin/customers/',
  CUSTOMER_GET: 'CUSTOMER_GET',
  CUSTOMER_DELETE: 'CUSTOMER_DELETE',
  CUSTOMER_PUT: 'CUSTOMER_PUT',
  CUSTOMER_POST: 'CUSTOMER_POST',
  CUSTOMER_GET_LIST: 'CUSTOMER_GET_LIST',
  CUSTOMER_GET_COUNT: 'CUSTOMER_GET_COUNT'
}



/** WEBPACK FOOTER **
 ** ./src/constants/CustomerConstants.js
 **/